import { render, staticRenderFns } from "./TraffictViolationEdit.vue?vue&type=template&id=471bf890&scoped=true"
import script from "./TraffictViolationEdit.vue?vue&type=script&lang=js"
export * from "./TraffictViolationEdit.vue?vue&type=script&lang=js"
import style0 from "./TraffictViolationEdit.vue?vue&type=style&index=0&id=471bf890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bf890",
  null
  
)

export default component.exports